import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export const Field = ({ label, value, onChange, testId, textarea, ...rest }) => {
  const Comp = textarea ? Textarea : Input;
  return (
    <div className="space-y-2">
      <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</Label>
      <Comp value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testId} className="bg-white" {...rest} />
    </div>
  );
};

export const Section = ({ title, hint, children }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-6 md:p-8">
    <h3 className="text-lg font-semibold">{title}</h3>
    {hint && <p className="mt-1 text-sm text-slate-500">{hint}</p>}
    <div className="mt-6 grid gap-5 sm:grid-cols-2">{children}</div>
  </div>
);
